import script from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarEventsDialog.vue?vue&type=style&index=0&id=0922bc58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0922bc58"]])

export default __exports__